const { $ } = window;

const REFRESH_IMPORT_PROGRESS_DELAY = 1000 * 10; // 10s

window.YP.DistributorManager = () => ({
    init() {
        if ($('#provider_import_table').length) {
            this.initImportsList();
        } else if ($('#import_distributor_type').length) {
            this.initNewImportFile();
        } else if ($('.distributor-import-form').length) {
            this.initNewImportConfiguration();
        }
    },
    initImportsList() {
        this.getProviderImportProgress();
    },
    initNewImportFile() {
        // Display description according to the selected distributor type
        $('#import_distributor_type').change(function onImportDistributorTypeChange() {
            $('.distributor_help').hide();
            $(`.distributor_help.distributor_${$(this).val()}`).show();
        }).change();

        // Set the download template
        $('#template-form-select').change(function changeDownloadTemplateLink() {
            const url = $('.js-download-form-gabarit-link').attr('href');
            const newFormId = $(this).val();
            const newUrl = url.replace(/([?&]formId)=([^#&]*)/g, `$1=${newFormId}`);
            $('.js-download-form-gabarit-link').attr('href', newUrl);
        }).change();
    },
    initNewImportConfiguration() {
        $('.distributor-import-form').submit(function setLoadingStateOnSubmit() {
            $(this).find('button:submit')
                .attr('disabled', 'disabled')
                .html('<i class="fa fa-spinner fa-spin fa-lg"></i>');
        });
        $('.distributor-sendmail').change(function toggleLanguageBlockOnSendmailChange() {
            const languageBlock = $('.js-select-language');
            languageBlock[$(this).prop('checked') ? 'show' : 'hide']();
        }).change();
    },
    getProviderImportProgress() {
        $.ajax({
            type: 'GET',
            url: $('#provider_import_table').find('table').data('refresh-url'),
            async: false,
            dataType: 'json',
            context: this,
        }).success((data) => {
            $.each(data, (index, value) => {
                $(`.provider_progress_${index}`).html(value.progress);
                $(`.provider_status_${index}`).html(value.status);
            });
        }).always(() => {
            window.setTimeout(
                this.getProviderImportProgress,
                REFRESH_IMPORT_PROGRESS_DELAY,
            );
        });
    },
});

window.addEventListener('load', () => window.YP.DistributorManager().init());
